import React, { useEffect } from 'react';
import rinStop from '../assets/images/warning/rin_stop.png';

const STORAGE_KEY = 'adultContentAccepted';

const AdultContentModal: React.FC = () => {
    useEffect(() => {
        const accepted = localStorage.getItem(STORAGE_KEY);
        const modalEl = document.getElementById('adultContentModal');

        if (accepted) {
            document.body.classList.remove('modal-open');
            document.body.style.removeProperty('overflow');
            document.body.style.removeProperty('padding-right');

            document.querySelectorAll('.modal-backdrop').forEach(b => b.remove());

            if (modalEl) {
                modalEl.classList.remove('show');
                modalEl.style.display = 'none';
                modalEl.style.pointerEvents = 'none';
                modalEl.setAttribute('aria-hidden', 'true');
            }

            return;
        }

        // Normal first-visit behavior
        if (modalEl) {
            // @ts-ignore
            const modal = new window.bootstrap.Modal(modalEl, {
                backdrop: 'static',
                keyboard: false
            });
            modal.show();
        }
    }, []);

    //useEffect(() => {
    //    const accepted = localStorage.getItem(STORAGE_KEY);

    //    if (!accepted) {
    //        // Bootstrap modal API (no React state needed)
    //        const modalEl = document.getElementById('adultContentModal');
    //        if (modalEl) {
    //            // @ts-ignore
    //            const modal = new window.bootstrap.Modal(modalEl, {
    //                backdrop: 'static', // prevent click-outside close
    //                keyboard: false     // prevent ESC close
    //            });
    //            modal.show();
    //        }
    //    }
    //}, []);

    const acceptAndContinue = () => {
        localStorage.setItem(STORAGE_KEY, 'true');

        const modalEl = document.getElementById('adultContentModal');
        if (!modalEl) return;

        // @ts-ignore
        const modal = window.bootstrap.Modal.getInstance(modalEl);
        if (!modal) return;

        modal.hide();

        modalEl.addEventListener(
            'hidden.bs.modal',
            () => {
                modal.dispose();

                // Remove Bootstrap body locks
                document.body.classList.remove('modal-open');
                document.body.style.removeProperty('padding-right');
                document.body.style.removeProperty('overflow');

                // Remove any lingering backdrops
                document.querySelectorAll('.modal-backdrop').forEach(b => b.remove());

                // Disable the modal element itself
                modalEl.classList.remove('show');
                modalEl.style.display = 'none';
                modalEl.style.pointerEvents = 'none';
                modalEl.setAttribute('aria-hidden', 'true');
            },
            { once: true }
        );
    };


    const leaveSite = () => {
        window.location.href = 'https://store.steampowered.com/app/3130330/Metaphor_ReFantazio__Prologue_Demo/';
    };

    return (
        <div
            className="modal fade adult-warning-modal"
            id="adultContentModal"
            tabIndex={-1}
            aria-labelledby="adultContentModalLabel"
            aria-hidden="true"
        >
            <div className="modal-dialog modal-dialog-centered modal-lg">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="adultContentModalLabel">
                            Adult Content Warning
                        </h5>
                    </div>

                    <div className="modal-body">
                        <div className="row g-3 align-items-center">
                            {/* Left image */}
                            <div className="col-md-5 text-center">
                                <img
                                    src={rinStop}
                                    alt="Adult Content Warning"
                                    className="img-fluid rounded"
                                />
                            </div>

                            {/* Right text */}
                            <div className="col-md-7 kanit-regular">
                                <h4 className="mb-3">18+ Content Ahead</h4>
                                <p>
                                    This website contains explicit adult material, including
                                    <strong> nude depictions of fictional loli characters</strong> and other contentious content.
                                </p>
                                <p className="mb-4">
                                    By continuing, you confirm that you are at least 
                                    <strong> 18 years old</strong> and that viewing such content
                                    is legal in your area.
                                </p>

                                <div className="d-flex gap-2">
                                    <button
                                        className="btn btn-primary"
                                        onClick={acceptAndContinue}
                                    >
                                        I am 18+ — Continue
                                    </button>

                                    <button
                                        className="btn btn-secondary"
                                        onClick={leaveSite}
                                    >
                                        Leave Site
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default AdultContentModal;
